export default {
  status: {
    pending: 'En attente du DNS',
    verified: 'En ligne',
    failed: 'Action requise',
  },
  summary: {
    preparing:
      'Les enregistrements pour {{host}} sont en cours de préparation. Ils apparaissent ici dans les 15 minutes environ — ou tout de suite après avoir cliqué sur Vérifier à nouveau.',
    pending:
      "En attente des enregistrements DNS ci-dessous. Cela prend généralement quelques minutes et peut aller jusqu'à 48 heures — nous continuons à vérifier de notre côté.",
    certificate_pending:
      "Les enregistrements sont en place. Le certificat pour {{host}} est en cours d'émission — cela prend généralement quelques minutes.",
    verified: 'La boutique en ligne est en ligne sur {{host}}.',
    serving: "La boutique en ligne est en ligne sur {{serving_host}}, mais {{host}} lui-même ne l'ouvre pas encore.",
    apex_elsewhere:
      "L'enregistrement A sur @ ne pointe pas encore vers la boutique. Si {{host}} affiche un site web qui doit y rester, laissez @ tel quel — la boutique fonctionne sur {{serving_host}}. Sinon, ajoutez l'enregistrement A ci-dessous.",
    apex_held:
      "{{host}} est utilisé par un autre site web sur Vercel. Pour que {{host}} ouvre aussi la boutique, retirez d'abord le domaine de ce site web.",
    regressed:
      '{{host}} fonctionnait, mais un enregistrement ci-dessous ne se vérifie plus. Corrigez-le chez le fournisseur DNS, puis cliquez sur Vérifier à nouveau.',
    record_elsewhere:
      'Un enregistrement ci-dessous pointe ailleurs. Remplacez-le chez le fournisseur DNS par la valeur indiquée, puis cliquez sur Vérifier à nouveau.',
    records_missing:
      "Les enregistrements ci-dessous sont toujours introuvables après 48 heures. Vérifiez qu'ils ont été enregistrés pour {{zone}}, chez le fournisseur qui gère son DNS. Si ce fournisseur ne permet pas la modification, le domaine y est peut-être verrouillé.",
    certificate: {
      ownership_proof_required:
        '{{host}} est aussi associé à un autre compte Vercel : le restaurant doit donc prouver que le domaine lui appartient.',
      held_by_another_project:
        "{{host}} est encore utilisé par un autre site web sur Vercel, la boutique ne peut donc pas encore l'utiliser.",
      dns_correct_but_unconfigured:
        'Les enregistrements sont corrects, mais autre chose sur {{host}} bloque le certificat.',
      name_mismatch: '{{host}} répond encore avec un certificat pour un autre nom.',
      expired: 'Le certificat pour {{host}} a expiré. Nous avons été alertés et nous nous en occupons.',
      expiring: "Le certificat pour {{host}} expire bientôt et n'a pas encore été renouvelé. Nous nous en occupons.",
      attach_refused:
        "Notre hébergeur a refusé d'ajouter {{host}} de notre côté. Nous avons été alertés et nous nous en occupons.",
      overdue: "Le certificat pour {{host}} n'a toujours pas été émis après 48 heures.",
      unknown: "Le certificat pour {{host}} n'a pas pu être émis.",
    },
    certificate_see_row: 'La ligne du certificat ci-dessous indique quoi faire.',
  },
  instructions: {
    title: 'Connecter {{host}}',
    step_provider:
      "Connectez-vous là où le DNS de {{zone}} est géré — en général l'entreprise auprès de laquelle le domaine a été acheté.",
    step_add: 'Ajoutez chaque enregistrement ci-dessous exactement comme indiqué : son type, son nom et sa valeur.',
    step_check: 'Enregistrez, puis cliquez sur {{button}}. Nous continuons aussi à vérifier de notre côté.',
    tip_name:
      'La plupart des fournisseurs veulent seulement la partie avant {{zone}} dans le champ du nom — ici {{names}}. Le nom complet est aussi affiché, pour les fournisseurs qui le demandent.',
    tip_apex: '@ désigne {{zone}} lui-même. Certains fournisseurs laissent le nom vide à la place.',
    tip_apex_website:
      'Si {{zone}} ouvre déjà un site web, faire pointer @ vers la boutique retire {{zone}} à ce site. Pour y garder le site web, laissez les enregistrements sur @ tels quels — la boutique fonctionne toujours sur www.{{zone}} — ou connectez plutôt un sous-domaine comme order.{{zone}} pour la boutique.',
    tip_existing:
      "Supprimez tout autre enregistrement A, AAAA ou CNAME sur {{name}}. Deux enregistrements qui pointent vers des endroits différents font que la boutique ne se charge qu'une partie du temps.",
    tip_cloudflare:
      'Sur Cloudflare, réglez ces enregistrements sur DNS uniquement (nuage gris). Avec le proxy activé, personne ne voit où ils pointent et aucun certificat ne peut être émis.',
    tip_locked:
      "Si le fournisseur ne permet pas d'ajouter ou de modifier ces enregistrements, le domaine est peut-être verrouillé, ou son DNS est géré ailleurs. Le fournisseur peut le déverrouiller ou indiquer où son DNS est géré.",
  },
  records: {
    title: 'Enregistrements pour {{host}}',
  },
  separate_domains: {
    apex: "Ce domaine est réservé à la boutique en ligne : la boutique occupe {{zone}} et www.{{zone}}. Un site web a besoin d'un autre nom — un sous-domaine de {{zone}} ou un domaine qui lui est propre.",
    subdomain: 'Ce domaine est réservé à la boutique en ligne. Un site web peut utiliser {{zone}} ou www.{{zone}}.',
  },
  load_error: "Impossible de charger l'état du domaine.",
  no_access: "Aucun accès à l'état du domaine de ce restaurant.",
  polling_stopped: "Cette page ne s'actualise plus d'elle-même. Cliquez sur Vérifier à nouveau pour l'actualiser.",
  buttons: {
    check_again: 'Vérifier à nouveau',
    retry: 'Réessayer',
  },
  toasts: {
    check_started: 'Vérification des enregistrements. Cela peut prendre une minute.',
    check_failed: 'Impossible de lancer la vérification. Veuillez réessayer.',
    check_too_soon: "Vérifié à l'instant. Veuillez patienter une minute avant de vérifier à nouveau.",
  },
};
